export enum NoteTypeEnum {
  COMPANY = 1,
  PRODUCT = 2,
  TRANSACTION = 3,
}
